import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

type Props = {
  label: string,
  onClick?: () => void,
  disabled?: boolean,
  isLoading?: boolean,
  type?: string,
  className?: string,
  size?: 'small' | 'medium' | 'large',
  fullWidth?: boolean,
  color?: 'default' | 'danger',
}

export default function PrimaryButton({ onClick, label, type, disabled = false, isLoading = false, className = '', size, fullWidth = false, color = 'default' }: Props) {
  const bg = color === 'danger' ? '#F40000' : '#000';
  return (
    <Button
      variant="text"
      size={size}
      fullWidth={fullWidth}
      className={`primary-button-component ${className}`}
      sx={{
        backgroundColor: bg,
        '&.Mui-disabled': { backgroundColor: 'grey', color: '#fff' },
      }}
      onClick={onClick}
      type={(type as any) ?? 'submit'}
      disabled={disabled || isLoading}
    >
      {isLoading ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : label}
    </Button>
  )
}
